import { useState } from "react";
import { useContext, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Route, Switch } from "react-router";
import { CurrentPContext, MasterContext } from "../ContextApi/context";
import masterUtil from "../_Utils/utilsMaster";
import Sitemap from "../web_pages/SiteMap/SiteMap";
import ConnUrls from "../Connections/ConnectURL";
import buildLocalBusinessSchema from "../_Utils/buildSeoSchema";
import '../Styles/Style.css'
import '../Styles/LolaStyle.css'
import '../Styles/MySetStyle.css'
import '../Styles/DesktopStyle.css'
import '../Styles/MobiStyle.css'
import '../Styles/animate.css'
import '../Styles/bootstrap.min.css'

import parse from 'html-react-parser';



const MasterHeadComp = () => {

  const [master, setMaster] = useContext(MasterContext);
  const [currentPage, setCurrentPage] = useContext(CurrentPContext);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    if (master == null) {
      setThemast();
    }

    setLoading(false)
  }, [])

  let canonicalURl = "";

  const setThemast = async () => {
    let mast = await masterUtil.getMaster();

    setMaster(mast);

  }

  const localBusinessSchema = buildLocalBusinessSchema(master, window.location.origin);

  return (
    <>
      {loading ? "" :
        <Helmet

          title={currentPage.pageName || master?.mainTitle || master?.seoH1Title || "לולה אשדוד"}
          meta={[
            {
              name: "description",
              property: "og:description",
              content: master?.sEOdescription || master?.mainTitle || ""
            },
            {
              name: "keywords",
              property: "og:keywords",
              content: master?.sEOkeywords || master?.mainTitle || ""
            },
            { property: "og:title", content: currentPage.pageName || master?.mainTitle || master?.seoH1Title || "לולה אשדוד" },
            { property: "og:url", content: decodeURI(window.location.href) },
            ...(master?.seoMainImage ? [{ property: "og:image", content: `${ConnUrls.servMediasUrl}/${master.seoMainImage}` }] : [])
          ]}

        >
          <link rel="canonical" href={decodeURI(window.location.href)} />
          <link rel="alternate" href={decodeURI(window.location.href)} hreflang="he" />
          {localBusinessSchema &&
            <script type="application/ld+json">
              {JSON.stringify(localBusinessSchema)}
            </script>
          }
        </Helmet>




      }
    </>
  );
}

export default MasterHeadComp;
